import { render, staticRenderFns } from "./ItemPartAssets.vue?vue&type=template&id=3bfaa1f8&scoped=true&"
import script from "./ItemPartAssets.vue?vue&type=script&lang=js&"
export * from "./ItemPartAssets.vue?vue&type=script&lang=js&"
import style0 from "./ItemPartAssets.vue?vue&type=style&index=0&id=3bfaa1f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfaa1f8",
  null
  
)

export default component.exports